import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TopNavComponent } from './topnav.component';

@NgModule({
    imports: [RouterModule, CommonModule],
    declarations: [TopNavComponent],
    exports: [TopNavComponent],
    providers: []
})

export class TopNavModule {}
